import HomeIcon from '@atlaskit/icon/core/home';
import React from 'react';

export const SvgHome = () => <HomeIcon label="" testId="ads-refreshed-icon" />;
